import dayjs from 'dayjs';
import ActionResultType from '../../../interfaces/pieces/ActionResultType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type { BaseLiquidationOptions } from '../../../interfaces/pieces/mouvements/liquidation/BaseLiquidationOptions';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type TreeviewActionResult from '../../../interfaces/pieces/TreeviewActionResult';
import { updateBordereau } from '../../../services/piecesComptables/bordereaux/bordereaux';
import getMessageErreur from '../../../utils/getMessageErreur';
import BaseLiquidationAction from '../../pieces/BaseLiquidationAction';

class BordereauForceTraiteDGFIPAction extends BaseLiquidationAction<
	BordereauWithState,
	BordereauActionType
> {
	constructor(options: BaseLiquidationOptions) {
		super(options);
		this.label = 'Considérer traité par la DGFIP';
		this.type = BordereauActionType.FORCE_TRAITE_DGFIP;
	}

	execute = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		result: Promise.resolve(bordereau),
		type: ActionResultType.MODAL,
		extraProps: {
			isSuperUser: this.isSuperUser,
			priseEnChargeModal: {
				visible: true,
			},
		},
	});

	executeAction = (
		bordereau: BordereauWithState,
	): TreeviewActionResult<BordereauWithState> => ({
		type: ActionResultType.UPDATE,
		result: new Promise((resolve, reject) => {
			updateBordereau(
				{
					...bordereau,
					retourPesOk: true,
					dernierChangement: dayjs().format('YYYY-MM-DD HH:mm:ss'),
				},
				new URLSearchParams({ withJournaux: 'true' }),
			)
				.then((updatedBordereau) => {
					resolve(updatedBordereau);
				})
				.catch((e) => {
					reject(
						Error(
							getMessageErreur(
								e,
								'Erreur lors de la modification du bordereau',
							),
						),
					);
				});
		}),
		shouldRefreshChildren: true,
	});
}

export default BordereauForceTraiteDGFIPAction;
